import React, { useEffect, useState } from 'react';

import { ScrollTrackingBlockData } from 'api/cms';
import ScrollWatcherContainer from 'containers/ScrollWatcherContainer';
import { trackEvent } from 'utils/analytics';

type Props = {
  data: ScrollTrackingBlockData;
};

export function ScrollTrackingBlock({ data: { eventName } }: Props) {
  const [tracked, setTracked] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const onScroll = () => {
    if (!scrolled) {
      setScrolled(true);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  });

  return (
    <ScrollWatcherContainer>
      {({ isInViewport }) => {
        if (isInViewport && !tracked) {
          trackEvent(`Scroll: ${eventName}`, {
            reached_through: scrolled ? 'Scrolling' : 'Page Load',
          });
          setTracked(true);
        }

        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
      }}
    </ScrollWatcherContainer>
  );
}
